// Auth state
export const REAUTH = 'REAUTH';
export const AUTH_OUTAGE = 'AUTH_OUTAGE';
export const AUTH_HEALTHY = 'AUTH_HEALTHY';
export const CHECK_AUTH_HEALTH = 'CHECK_AUTH_HEALTH';

// User actions
export const GUEST_LOGIN_START = 'GUEST_LOGIN_START';
export const LOGIN_START = 'LOGIN_START';
export const SUBMIT_PHONE_NUMBER = 'SUBMIT_PHONE_NUMBER';
export const SUBMIT_PHONE_OTP = 'SUBMIT_PHONE_OTP';
export const SUBMIT_EMAIL = 'SUBMIT_EMAIL';
export const SUBMIT_EMAIL_OTP = 'SUBMIT_EMAIL_OTP';
export const SUBMIT_GOOGLE_TOKEN = 'SUBMIT_GOOGLE_TOKEN';
export const SUBMIT_FACEBOOK_TOKEN = 'SUBMIT_FACEBOOK_TOKEN';
export const SUBMIT_LINE_TOKEN = 'SUBMIT_LINE_TOKEN';
export const SUBMIT_ACCOUNT_RECOVERY_OTP = 'SUBMIT_ACCOUNT_RECOVERY_OTP';
export const SUBMIT_MAGIC_LINK_OTP = 'SUBMIT_MAGIC_LINK_OTP';

// Internal actions
export const HANDLE_AUTH_RESPONSE = 'HANDLE_AUTH_RESPONSE';
export const GUEST_LOGIN_SUCCESS = 'GUEST_LOGIN_SUCCESS';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const GUEST_UNAUTHORIZED = 'GUEST_UNAUTHORIZED';

// Auth factors
export const RESEND_EMAIL_OTP = 'RESEND_EMAIL_OTP';
export const RESEND_PHONE_OTP = 'RESEND_PHONE_OTP';
export const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
export const SET_MAGIC_LINK_TYPE = 'SET_MAGIC_LINK_TYPE';
export const SET_ONBOARDING_TOKEN = 'SET_ONBOARDING_TOKEN';
export const SET_ONBOARDING_USER_ID = 'SET_ONBOARDING_USER_ID';
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN';
export const SET_APPEAL_TOKEN = 'SET_APPEAL_TOKEN';
export const SET_AUTH_TOKEN_EXPIRATION = 'SET_AUTH_TOKEN_EXPIRATION';
export const SET_CAPTCHA_TYPE = 'SET_CAPTCHA_TYPE'; // Onboarding captcha
export const SET_SMS_CAPTCHA_TOKEN = 'SET_SMS_CAPTCHA_TOKEN'; // Pre-sms captcha
export const SET_AUTH_FUNNEL_SESSION_ID = 'SET_AUTH_FUNNEL_SESSION_ID';
export const SET_CAPTCHA_KEY = 'SET_CAPTCHA_KEY';

// Login button combinations
export const AUTH_OPTIONS_VARIANT_SMS_FB = 1;
export const AUTH_OPTIONS_VARIANT_GOOGLE = 2;
export const AUTH_OPTIONS_VARIANT_GOOGLE_SMS = 3;
export const AUTH_OPTIONS_VARIANT_GOOGLE_FB_SMS = 4;
export const AUTH_OPTIONS_VARIANT_LINE_GOOGLE = 6; // Skipping 5 to maintian parity with android line rollout
export const AUTH_OPTIONS_VARIANT_HIDDEN_SMS_GOOGLE_FB = 7;
export const AUTH_OPTIONS_VARIANT_NO_SMS_GOOGLE_FB = 8;

// Line oAuth Code Constants
export const LINE_CONNECT_AUTH = 'LINE_CONNECT_AUTH';

// LocalStorage Line Persistance Key
export const PERSIST_LINE_BUTTON = 'TinderWeb/PersistLineButton';

// Request Verification
export const SET_SELFIE_CHALLENGE_TOKEN = 'SET_SELFIE_CHALLENGE_TOKEN';
export const SET_SELFIE_CHALLENGE_V2_STATUS = 'SET_SELFIE_CHALLENGE_V2_STATUS';
